<template>
  <div>
    <div class="layout-header" ref="searchBox">
      <div class="infor-layout-header">
        <span class="title">区域核定量设置</span>
      </div>
    </div>
    <div style="height: 6rem"></div>
    <div class="pagination-bg-white layout-header">
      <w-table
        width="100%"
        v-show="checkUserAuth(4, 14)"
        v-loading.body="tableLoading"
        :bPagination="false"
        :height="tableViewHeight"
        :data-list="tabledata"
        :columns="columns"
      >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '操作'">
            <el-button
              v-show="checkUserAuth(4, 12) && !props.row.isCreated"
              size="mini"
              @click="onEdit(props.row)"
              >修改</el-button
            >
          </span>
          <span v-else>{{ props.row[props.column.property] }}</span>
        </template>
      </w-table>
    </div>
    <w-dialog
      ref="w-dialog"
      title="核定量修改保存成功！"
      width="600"
      :isShowFooter="true"
      @handleClose="handleClose3"
      @handleCloseRight="handleClose3"
      @onSure="onSure3"
    >
      <template v-slot:content>
        <el-form
          label-width="6.875rem"
          ref="formLabelAlignRuleForm"
          :model="formLabelAlign"
          :rules="formLabelAlignRules"
        >
          <div style="margin-bottom: 1rem">
            品牌: {{ formLabelAlign.brandName }}
          </div>
          <el-form-item label="自行车核定量：" prop="bike">
            <el-input
              v-model="formLabelAlign.brandAreaBikeNum"
              style="width: 80%"
            ></el-input>
            <span
              style="
                margin-left: 0.5rem;
                font-size: 0.75rem;
                color: rgba(0, 0, 0, 0.25);
              "
              >辆</span
            >
          </el-form-item>
          <el-form-item label="电动车核定量：" prop="ebike">
            <el-input
              v-model="formLabelAlign.brandAreaEleBikeNum"
              style="width: 80%"
            ></el-input>
            <span
              style="
                margin-left: 0.5rem;
                font-size: 0.75rem;
                color: rgba(0, 0, 0, 0.25);
              "
              >辆</span
            >
          </el-form-item>
        </el-form>
        <span
          style="margin-left: 1.5rem; font-size: 0.75rem; color: rgba(0, 0, 0, 0.25)"
          >注：该设定只针对运营统计的城市核定投放统计有效</span
        >
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from "@/api";
import WDialog from "@/components/Model/index.vue";
import WTable from "@/components/Table/index.vue";

import { mapGetters } from "vuex";
export default {
  components: {
    WDialog,
    WTable,
  },
  data() {
    var bikeNum = (rule, value, callback) => {
      if (String(value).indexOf(".") !== -1) {
        callback(new Error("请输入合法电动车数量"));
      }
      if (value < 0) {
        callback(new Error("请输入合法自行车数量"));
      }
      callback();
    };

    var ebikeNum = (rule, value, callback) => {
      if (String(value).indexOf(".") !== -1) {
        callback(new Error("请输入合法电动车数量"));
      }
      if (value < 0) {
        callback(new Error("请输入合法电动车数量"));
      }
      callback();
    };

    return {
      tableViewHeight: "",
      columns: [
        {
          prop: "brandName",
          label: "品牌名称",
        },
        {
          prop: "brandOperation",
          label: "企业名称",
        },
        {
          prop: "brandAreaEleBikeNum",
          label: "电动车总量",
        },
        {
          prop: "brandAreaBikeNum",
          label: "自行车总量",
        },
        {
          fixed: "right",
          label: "操作",
        },
      ],
      tableLoading: true,
      tabledata: [],
      formLabelAlign: {},
      formLabelAlignRules: {
        bike: [
          {
            validator: bikeNum,
            message: "请填写合法自行车数量",
            trigger: "blur",
          },
        ],
        ebike: [
          {
            validator: ebikeNum,
            message: "请填写合法电动车数量",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["user", "selfAreaId", "userLevel"]),
  },
  created() {
    if (this.userLevel !== 2) {
      let path = "/CompanyManagement/company/";
      if (this.selfAreaId) {
        path += this.selfAreaId;
      }
      this.$router.push(path);
      return;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.tableLoading = true;
      Api.getAreaBrandList(this.selfAreaId).then((res) => {
        this.tableLoading = false;
        if (res.code === 200 && res.data) {
          if (res.data.length > 0) {
            this.tabledata = res.data.filter(it => it.isDelete);
          }
        } else {
          this.$message.warning(res.message);
        }
        this.calcView();
      });
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0;
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight);
        }
        console.log("H", H);
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56;
      });
    },
    onEdit(data) {
      Api.getBikeSum(this.selfAreaId).then((res) => {
        if (res.code === 200) {
          if (res.data.areaBikeNum + res.data.areaEleBikeNum == 0) {
            let path = "/CompanyManagement/sum/";
            if (this.selfAreaId) {
              path += this.selfAreaId;
            }
            this.$router.push(path);
          } else {
            this.formLabelAlign = { ...data };
            this.$refs["w-dialog"].onShowDialog();
          }
        } else {
          vm.$message.warning(res.message);
        }
      });
    },
    onSure3() {
      this.$refs.formLabelAlignRuleForm.validate((valid) => {
        if (valid) {
          this.handleformLabelAlignFormRole();
        } else {
          return false;
        }
      });
    },
    handleformLabelAlignFormRole() {
      Api.setAreaBrandNumber(
        {
          brandAreaBikeNum: Number(this.formLabelAlign.brandAreaBikeNum),
          brandAreaEleBikeNum: Number(this.formLabelAlign.brandAreaEleBikeNum),
          brandId: this.formLabelAlign.brandId,
        },
        this.selfAreaId
      )
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("核定量修改保存成功！");
            this.handleClose3();
            this.getData();
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClose3() {
      this.formLabelAlign = {};
      this.$refs["w-dialog"].onCloseDialog();
    },
  },
};
</script>

<style lang="less">
.layout-header {
  margin: 16px;
  width: calc(100% - 20px);
}
</style>
